// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

// Componets

import { FormElems } from '..';

// Styles
import './netBankCard.scss';

/**
 * NetBankCard Component
 *
 * @param {Object} props - React component props
 */
const NetBankCard = props => {
    const { customClass, data } = props;
    return (
        <ul
            className={`netbanking-container ${customClass ? customClass : ''}`}
        >
            {data.map(bankValues => {
                const {
                    percentageDetail,
                    flatDetail,
                    taxDetails,
                    criteriaDetails,
                    bankDetails,
                } = bankValues;
                return (
                    <li>
                        <div className="form-section">
                            <div className="form-field">
                                <p className="label">{bankDetails.label}</p>
                                <Field
                                    name="criteria"
                                    data={bankDetails.options}
                                    labelField="label"
                                    valueField="value"
                                    component={FormElems.Select}
                                    placeholder={bankDetails.placeholder}
                                    label={bankDetails.placeholder}
                                />
                            </div>
                            <div className="form-field number">
                                <p className="label">
                                    {percentageDetail.label}
                                </p>
                                <Field
                                    name={percentageDetail.name}
                                    value={percentageDetail.value}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                />
                            </div>
                            <div className="form-field number">
                                <p className="label">{flatDetail.label}</p>
                                <Field
                                    name={flatDetail.label}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">{criteriaDetails.label}</p>
                                <Field
                                    name="criteria"
                                    data={criteriaDetails.options}
                                    labelField="label"
                                    valueField="value"
                                    component={FormElems.Select}
                                    placeholder={criteriaDetails.placeholder}
                                    label={criteriaDetails.placeholder}
                                />
                            </div>
                            <div className="form-field number">
                                <p className="label">{taxDetails.label}</p>
                                <Field
                                    name={taxDetails.name}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                />
                            </div>
                            <div className="form-field action">
                                <FormElems.Button
                                    type="button"
                                    buttonType="secondary"
                                    text="x Add Bank"
                                    customClass="btn-small"
                                />
                            </div>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

NetBankCard.propTypes = {
    /* String to add custom class in accordion */
    customClass: PropTypes.string,
    /* Array of object for all data to render slab card Ui*/
    data: PropTypes.array,
};

export default NetBankCard;
